import script from "./EditShopInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShopInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditShopInfoDialog.vue?vue&type=style&index=0&id=06918848&lang=css"

const __exports__ = script;

export default __exports__